var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trend"},[_vm._m(0),_c('div',{ref:"box",staticClass:"box",attrs:{"id":"box"}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('h2',[_vm._v("安全风险监测趋势")])])
}]

export { render, staticRenderFns }